import { MatExpansionModule } from '@angular/material';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { GridTableComponent } from './grid-table.component';
// import { RnplCommonModule } from 'common/src/modules';


@NgModule({
  declarations: [
    GridTableComponent
  ],
  exports: [
    GridTableComponent
  ],
  imports: [
    CommonModule,
    // RnplCommonModule,
    TranslateModule,
    MatExpansionModule
  ],
})
export class GridTableModule { }
